var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nav notification-bell", class: _vm.isOpen && "is-open" },
    [
      _c(
        "button",
        {
          staticClass: "notification-bell__btn",
          attrs: { "data-id": "header-notifications-bell" },
          on: { click: _vm.notifyClick }
        },
        [
          _c(
            "div",
            {
              staticClass: "notification-bell__badge-count",
              attrs: { "data-id": "total-count-badge" }
            },
            [_c("span", [_vm._v(_vm._s(_vm.displayCounter))])]
          ),
          _c("i", { staticClass: "icon icon-notification-2" })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }